import { z } from 'zod';

import { AgentCategory } from '@/services/ws-genai/src/main/resources/rest-api';

// other scenes deep-link into the chat with ?agentCategory=<AgentCategory>&message=<text>
export const chatSearchParamsSchema = z.object({
  agentCategory: z.nativeEnum(AgentCategory).optional(),
  message: z.string().optional(),
});

export type ChatSearchParams = z.infer<typeof chatSearchParamsSchema>;
